const SCRIPT_SRC =
  "https://cdn.jsdelivr.net/npm/tarteaucitronjs@1.27.1/tarteaucitron.min.js";
const SCRIPT_INTEGRITY = "sha256-jYlWXwl4x64RtXMGnT4UqjNuYuj+w9AqjmUIj2OeE24=";

let loaderPromise;
let initialized = false;
let fallbackTimer = null;

const loadScript = () => {
  if (typeof window === "undefined") return Promise.resolve();
  if (window.tarteaucitron) return Promise.resolve(window.tarteaucitron);

  const existing = document.querySelector("script[data-tarteaucitron]");
  if (existing) {
    return new Promise((resolve, reject) => {
      existing.addEventListener("load", () => resolve(window.tarteaucitron));
      existing.addEventListener("error", () =>
        reject(new Error("tarteaucitron script failed to load")),
      );
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = SCRIPT_SRC;
    script.integrity = SCRIPT_INTEGRITY;
    script.crossOrigin = "anonymous";
    script.async = true;
    script.dataset.tarteaucitron = "js";
    script.onload = () => resolve(window.tarteaucitron);
    script.onerror = () =>
      reject(new Error("tarteaucitron script failed to load"));

    document.head.appendChild(script);
  });
};

export const startTarteaucitron = async () => {
  if (typeof window === "undefined" || initialized) return loaderPromise;

  if (fallbackTimer) {
    clearTimeout(fallbackTimer);
    fallbackTimer = null;
  }

  if (!loaderPromise) {
    loaderPromise = loadScript()
      .then(() => {
        const tac = window.tarteaucitron;
        if (!tac)
          throw new Error("tarteaucitron is unavailable after script load");

        tac.init({
          privacyUrl: "" /* Privacy policy url */,
          bodyPosition:
            "bottom" /* or top to bring it as first element for accessibility */,

          hashtag: "#tarteaucitron" /* Open the panel with this hashtag */,
          cookieName: "tarteaucitron" /* Cookie name */,

          orientation: "bottom" /* Banner position (top - bottom) */,

          groupServices: false /* Group services by category */,
          showDetailsOnClick: true /* Click to expand the description */,
          serviceDefaultState: "wait" /* Default state (true - wait - false) */,

          showAlertSmall: false /* Show the small banner on bottom right */,
          cookieslist: false /* Show the cookie list */,

          closePopup: false /* Show a close X on the banner */,

          showIcon: false /* Show cookie icon to manage cookies */,
          // "iconSrc": "", /* Optionnal: URL or base64 encoded image */
          iconPosition:
            "BottomRight" /* BottomRight, BottomLeft, TopRight and TopLeft */,

          adblocker: false /* Show a Warning if an adblocker is detected */,

          DenyAllCta: true /* Show the deny all button */,
          AcceptAllCta: true /* Show the accept all button when highPrivacy on */,
          highPrivacy: true /* HIGHLY RECOMMANDED Disable auto consent */,

          handleBrowserDNTRequest: false /* If Do Not Track == 1, disallow all */,

          removeCredit: false /* Remove credit link */,
          moreInfoLink: true /* Show more info link */,

          useExternalCss: false /* If false, the tarteaucitron.css file will be loaded */,

          // "cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for multisite */

          readmoreLink: "" /* Change the default readmore link */,

          mandatory: true /* Show a message about mandatory cookies */,
          mandatoryCta: true /* Show the disabled accept button when mandatory on */,

          // "customCloserId": "", /* Optional a11y: Custom element ID used to open the panel */

          googleConsentMode: true /* Enable Google Consent Mode v2 for Google ads and GA4 */,

          partnersList: false /* Show the number of partners on the popup/middle banner */,
        });

        tac.user.googletagmanagerId = "GTM-W6MKFJD";
        (tac.job = tac.job || []).push("googletagmanager");
        (tac.job = tac.job || []).push("gcmanalyticsstorage");
        initialized = true;
      })
      .catch((err) => {
        console.error("[tarteaucitron] initialization failed", err);
        throw err;
      });
  }

  return loaderPromise;
};

const TarteaucitronPlugin = {
  install(Vue) {
    Vue.prototype.$tarteaucitronStart = startTarteaucitron;
  },
};

export default TarteaucitronPlugin;

export const scheduleTarteaucitronFallback = (delay = 8000) => {
  if (typeof window === "undefined" || loaderPromise) return;
  fallbackTimer = window.setTimeout(() => {
    startTarteaucitron();
  }, delay);
};
